import { IBiePlanningContext } from './bieprofile.models';
import { json, postBiz, rows } from '../core/coreapi';

const SERVICE = 'bieprofile';

export async function fetchBiePlanningContext(): Promise<IBiePlanningContext> {
  const response = await postBiz({
    s: SERVICE,
    a: 'getcontext',
  });
  return json(response);
}

export async function setBiePlanningCycle(
  planningCycleId: number,
): Promise<IBiePlanningContext> {
  const response = await postBiz({
    s: SERVICE,
    a: 'setplanningcycle',
    pci: planningCycleId,
  });
  return json(response);
}

export async function setBieHistoricalDataset(
  historicalDatasetId: number,
): Promise<IBiePlanningContext> {
  const response = await postBiz({
    s: SERVICE,
    a: 'sethistoricaldataset',
    hdi: historicalDatasetId,
  });
  return json(response);
}

export async function setBieScenario(
  scenarioId: number,
): Promise<IBiePlanningContext> {
  const response = await postBiz({
    s: SERVICE,
    a: 'setscenario',
    sci: scenarioId,
  });
  return json(response);
}

// export async function findBieLoadSessions(
//   request: BieLoadSessionFindRequest = {},
// ): Promise<BieLoadSessionFindResult> {
//   const normalizedRequest = {
//     ...defaultBieLoadSessionFindRequest,
//     ...request,
//   };

//   const response = await postBiz({
//     s: SERVICE,
//     a: 'find',

//     sch: normalizedRequest.search || '',
//     stc: normalizedRequest.stateCode || '',
//     plm: normalizedRequest.pageLimit,
//   });

//   return normalizeBieLoadSessionFindResult(
//     rows(response),
//     normalizedRequest.pageOffset,
//     normalizedRequest.pageLimit,
//   );
// }




// export interface IBieProfileService {
//   post<T>(action: string, payload: Record<string, unknown>): Promise<T>;
// }

// const unwrap = (response: IBiePlanningContextEnvelope): IBiePlanningContext => {
//   if (!response || response.rc < 1 || !response.sd) {
//     throw new Error('BIE Planning Context could not be loaded.');
//   }
//   return response.sd;
// };

// export const fetchBiePlanningContext = async (
//   service: IBieProfileService,
//   userId: number,
// ): Promise<IBiePlanningContext> => unwrap(await service.post<IBiePlanningContextEnvelope>(
//   'spx_bieprofile_getcontext', { userid: userId },
// ));

// export const setBiePlanningCycle = async (
//   service: IBieProfileService,
//   planningCycleId: number,
//   userId: number,
// ): Promise<IBiePlanningContext> => unwrap(await service.post<IBiePlanningContextEnvelope>(
//   'spx_bieprofile_setplanningcycle',
//   { planningcycleid: planningCycleId, userid: userId },
// ));

// export const setBieHistoricalDataset = async (
//   service: IBieProfileService,
//   historicalDatasetId: number,
//   userId: number,
// ): Promise<IBiePlanningContext> => unwrap(await service.post<IBiePlanningContextEnvelope>(
//   'spx_bieprofile_sethistoricaldataset',
//   { historicaldatasetid: historicalDatasetId, userid: userId },
// ));

// export const setBieScenario = async (
//   service: IBieProfileService,
//   scenarioId: number,
//   userId: number,
// ): Promise<IBiePlanningContext> => unwrap(await service.post<IBiePlanningContextEnvelope>(
//   'spx_bieprofile_setscenario',
//   { scenarioid: scenarioId, userid: userId },
// ));
